'use strict';


import { projectMode, threeJsVariables } from '../../../settings';
import { createHtmlElement } from '../../../functions';
import { changeLangToCurrent, getCurrentLang } from '../langSwitcher/langSwitcher';
import { Highway } from './Highway';
import { Railway } from './Railway';
import { Education } from './Education';
import { Leisure } from './Leisure';
import { Fun } from './Fun';
import { closePoiInfoWindowCardInOrbit } from '../../poi/poiCss';
import { buildingHoverOut } from '../../threejs/raycast';
import { Parks } from './Parks';
import { Deals } from './Deals';
import { Popup } from './Popup';

export class PublicLayers extends Popup{
    static layerScopes = [];
    static activeLayer = null;
    static active = false;
    static scope = null;
    
    constructor (parent) {
        super();
        if (projectMode.LiteMode.isActive() || !config.features.publicLayers) return;

        PublicLayers.active = config.features.publicLayers?.active || false;
        this.layers = config.features.publicLayers?.layers || [];
        this.checked = config.features.publicLayers?.checked || false;

        if (!PublicLayers.active) return;

        this.parent = parent;

        createDisplayOption.apply(this);
        PublicLayers.scope = this;
    }

    clickHandler(e) {
        const target = e.target;

        if (target.classList.contains('lord__icon') || target.classList.contains('public-layer__btn') || target.classList.contains('public-layer__btn-text')){

            let layerType;

            if (target.classList.contains('lord__icon') || target.classList.contains('public-layer__btn-text')) {
                layerType = target.parentElement.getAttribute('data-public-layer');
            } else if (target.classList.contains('public-layer__btn')) {
                layerType = target.getAttribute('data-public-layer');
            }
    
            if (threeJsVariables.cssLabelManager.isBlocked(layerType) && e.action !== 'backButton')
                return;

            const scope = PublicLayers.layerScopes.find(layer => layer.type === layerType);

            if (PublicLayers.activeLayer) {

                if (PublicLayers.activeLayer.type === scope.type){
                    PublicLayers.activeLayer.hide();
                    PublicLayers.activeLayer = null;
                } else {
                    PublicLayers.activeLayer.hide();
                    PublicLayers.activeLayer = scope;
                    scope.show();
                }

            } else {
                PublicLayers.activeLayer = scope;
                scope.show();
            }
            closePoiInfoWindowCardInOrbit();

            // if (PublicLayers.activeLayers.length > 1) {
            //     this.clearBtnToggle('show');
            // } else {
            //     this.clearBtnToggle('hide');
            // }
        }
    }

    // clearHandler() {
    //     PublicLayers.hide();
    //     PublicLayers.activeLayers = [];
    //     this.clearBtnToggle('hide');
    // }

    clearBtnToggle(action) {
        switch (action) {
            case 'show':
                this.clearAllBtn?.classList.remove('hidden');
                break;
            case 'hide':
                this.clearAllBtn?.classList.add('hidden');
                break;
        }
    }

    static animate(delta) {
        if (PublicLayers.isActive) {
            PublicLayers.layerScopes.forEach(el => el.update(delta));
        }
    }

    static addLayer(scope) {
        PublicLayers.layerScopes.push(scope);
    }

    static getLayer(type) {
        return PublicLayers.layerScopes.find(layer => layer.type === type);
    }
    
    static hideLabelsByDistance(state) {
        PublicLayers.layerScopes.forEach(scope => scope.hideLabelsByDistance(state));
    }

    static hide() {
        if (PublicLayers.activeLayer) {
            PublicLayers.activeLayer.hide();
        }
    }

    static show() {
        if (PublicLayers.activeLayer) {
            PublicLayers.activeLayer.show();
        }
    }

    static mouseOverHandler () {
		if (PublicLayers.activeLayer) {
			PublicLayers.activeLayer.mouseOverHandler();
		}
	}

	static mouseOutHandler () {
		if (PublicLayers.activeLayer) {
			PublicLayers.activeLayer.mouseOutHandler();
		}
	}

    static intersect(el) {
        if (!PublicLayers.isActive) return;

        const highwayLayer = PublicLayers.getLayer('highway');
        if (!highwayLayer || highwayLayer && !highwayLayer.active) return;
        switch (typeof el) {
            case 'object':
                if (el.userData.routeData.name) {
                    PublicLayers.scope.popupContent = el.userData.routeData.name[getCurrentLang()];
                    PublicLayers.scope.showPopup();
                    buildingHoverOut();
                } else {
                    PublicLayers.scope.hidePopup();
                }
                break;
            case 'string':
                PublicLayers.scope.updatePopupPosition();
                break;

            case 'undefined':
                PublicLayers.scope.hidePopup();
                break;

        }
    }

    static get isActive() {
        return PublicLayers.active;
    }
}

function createDisplayOption () {
    this.routsContainer = createHtmlElement(this.parent,'','div',['public-layers','display-option']);
    createHtmlElement(this.routsContainer,'','div',['public-layers__toggle-block']);
    // const title = createHtmlElement(toggleBlock,changeLangToCurrent('Public layers'),'span',['public-layers__title','language-string']);
    // title.setAttribute('data-dictionary','Public layers');
    // this.clearAllBtn = createHtmlElement(toggleBlock,changeLangToCurrent('clear layers'),'button',['public-layers-clear-btn','language-string','hidden']);
    // this.clearAllBtn.setAttribute('data-dictionary','clear layers');
    // this.clearAllBtn.addEventListener('click', this.clearHandler.bind(this));

    // const checkedSwitcher = config.features.publicLayers.checked;

    // this.toggle = new Switch(toggleBlock);
    // this.toggle.checked = checkedSwitcher;
    // this.toggle.listener = this.toggleHandler.bind(this);

    this.publicRoutsContainer = createHtmlElement(this.routsContainer,'','div',['public-layers__elements']);

    // !checkedSwitcher && this.publicRoutsContainer.classList.add('disabled');

    this.layers.forEach(layerData => {
        if (!layerData.active)
            return;

        let layer;

        switch (layerData.type) {
            case 'highway':
                layer = new Highway(this.publicRoutsContainer,layerData);
                break;

            case 'parks':
                layer = new Parks(this.publicRoutsContainer,layerData);
                break;

            case 'railway':
                layer = new Railway(this.publicRoutsContainer,layerData);
                break;

            case 'education':
                layer = new Education(this.publicRoutsContainer,layerData);
                break;

            case 'leisure':
                layer = new Leisure(this.publicRoutsContainer,layerData);
                break;

            case 'fun':
                layer = new Fun(this.publicRoutsContainer,layerData);
                break;
            case 'deals':
                layer = new Deals(this.publicRoutsContainer,layerData);
                break;
            // case '360':
            //     layer = new Orbit360(this.publicRoutsContainer,layerData);
            //     break;

        }

        if (layer) {
            PublicLayers.addLayer(layer);
        }
    });

    this.publicRoutsContainer.addEventListener('click', this.clickHandler.bind(this));

    // const event = new Event('change');
    // this.toggle.checkbox.dispatchEvent(event);
}

window.pl = PublicLayers;
